// UTILITY
import bugsnag from '@/utility/bugsnagClient';
import localStore from '@/utility/store';
import { getReferrer } from '@/utility/routes';

// STORE
import store from '@/store/configureStore';

const env = import.meta.env.VITE_ENV;
const testOrLife = env !== 'production' ? 'test' : 'live';
const domain = window.location.hostname;

export const defAnalyticsData = {
  test_or_live: testOrLife,
  domain,
  pageTitle: '',
  query_params: '',
  mybundle_id: '',
  partner_id: '',
  unique_id: '',
  referrer: '',
};

export function getDefaultAnalyticsData(data = {}) {
  const state = store.getState();

  const { user, partner, anonymousId } = state.auth;
  const partnerId = partner?.partner_id;
  const referrer = getReferrer();

  return {
    ...defAnalyticsData,
    pageTitle: document.title || '',
    query_params: window.location.search,
    mybundle_id: user?.id || data.user?.id || '',
    partner_id: partnerId || data.partner?.id || '',
    unique_id: anonymousId || '',
    referrer,
  };
}

export const customAnalyticsEvent = (action, data = {}) => {
  const defaultData = getDefaultAnalyticsData();

  const properties = {
    ...defaultData,
    ...data,
  };

  if (window.analytics) {
    window.analytics.track(action, properties);
  } else {
    bugsnag.notify(
      new Error(
        `Unable to send statistics via segment, action - ${action}, prop - ${JSON.stringify(
          properties,
        )}`,
      ),
    );
  }
};

export const analyticsGetUserId = () => {
  let userId = '';

  if (window.analytics && window.analytics.user) {
    userId = window.analytics.user().anonymousId();
  }

  return userId;
};

export const analyticsPageLoaded = (pageName = null) => {
  const defaultData = getDefaultAnalyticsData();

  if (window.analytics) {
    setTimeout(() => {
      window.analytics.page(pageName || window.location?.pathname, {
        ...defaultData,
      });
    }, 0);
  }
};

export const analyticsIdentify = (identifier, properties, options = {}) => {
  const defaultData = getDefaultAnalyticsData();

  if (window.analytics && identifier) {
    localStore.remove('ajs_user_traits');

    window.analytics.identify(
      identifier,
      {
        ...defaultData,
        ...properties,
      },
      options,
    );
  }
};

export const analyticsAuth = (data = {}) => {
  const defaultData = getDefaultAnalyticsData(data);

  const properties = {
    ...defaultData,
    user_id: data.user_id,
    email: data.email,
    HASACC: true,
  };

  analyticsIdentify(data.email, properties);
};

export const externalLink = (data = {}) => {
  const defaultData = getDefaultAnalyticsData();
  const action = 'External Link Clicked';
  const state = store.getState();

  const { partner } = state.auth;

  const properties = {
    ...data,
    slot: data.slot || '',
    bundle_id: data.bundle_id || '',
    location: data.location || '',
    service_id: data.service_id || '',
    service_name: data.service_name || '',
    href: data.href || '',
    app_id: data.app_id ?? '',
    other: data.other || '',
    type: data.type || '',
    page: data.page_name || window.location?.pathname || '',
    is_affiliate: data.is_affiliate || false,
    partner: data.partner || partner.slug || '',
    partner_id: data.partner_id || defaultData.partner_id || 0,
    content_id: data.content_id || '',
    content_title: data.content_title || '',
  };

  customAnalyticsEvent(action, properties);
};

export const getExternalUrlParams = (data = {}) => {
  const defaultData = getDefaultAnalyticsData();

  return {
    unique_id: data.unique_id || defaultData.unique_id,
    source: data.source || defaultData.referrer,
    page: data.page || window.location?.pathname || '',
    phone_number: data.phone || '',
  };
};

export default defAnalyticsData;
